module.exports = __webpack_public_path__ + "img/HOMECREDIT.8366bbaa.svg";